import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesOverview from './components/ServicesOverview';
import MidPageCTA from './components/MidPageCTA';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

export default function HomePage() {
  return (
    <div className="font-sans bg-warm-white overflow-x-hidden">
      <Header />
      <main>
        {/* 1. Hero — full-screen cinematic */}
        <HeroSection />

        {/* 2. Trust bar — slides under hero */}
        <TrustBar />

        {/* 3. Services — rounded top, layered over trust */}
        <ServicesOverview />

        {/* Mid CTA #1 — between Services and AI block */}
        <MidPageCTA variant="primary" />

        {/* 4. AI Answers — dark block with depth */}
        <AIAnswerBlock />

        {/* 5. Process — cinematic background */}
        <ProcessSection />

        {/* 6. Why Choose Us — layered card, stats + agent */}
        <WhyChooseUs />

        {/* 7. Service Areas — map + locations */}
        <ServiceAreas />

        {/* 8. Testimonials — dark card layout */}
        <Testimonials />

        {/* Mid CTA #2 — between Testimonials and FAQ */}
        <MidPageCTA variant="secondary" />

        {/* 9. FAQ — voice-search optimized */}
        <FAQSection />

        {/* 10. Final CTA — form + emotional headline */}
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}